module.exports = __webpack_public_path__ + "img/白头翁.6dd0be6e.jpg";